export default __webpack_public_path__ + "static/media/circle-r-bottom.b73910a2.png";